<template>
  <div>
    <!-- location.reload(true); -->
  </div>
</template>

<script>
import axios from 'axios'
import store from '@/store'
export default {
  data () {
    return {
      sseUrl: 'https://scmg.zczy56.com/zczy-link-server/stream-sse',
      source: null,
      timer: null
    }
  },
  created () {
    this.startSSEConnection()
  },
  methods: {
    async handleData (event) {
      console.log(event);
      await store.dispatch('log/getMenuList')
   
    },
    startSSEConnection() {
    // 发送 AJAX 请求初始化连接
    let userId=localStorage.getItem('userId');
    let respList =localStorage.getItem('respList')?JSON.parse(localStorage.getItem('respList')):'';
    let roleIds = respList.map(item => item.roleId);
    fetch(this.sseUrl,
    {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                // Add your ConnectionParam properties here
                userId: userId,
                groupIds: roleIds,
            })
        }) .then(response => {
      // 建立 SSE 连接
      this.startSSE();
    }).catch(error => {
      console.error('Error initializing SSE connection:', error);
    });
  },
    startSSE () {
      if (typeof (EventSource) !== "undefined") {
        // 创建一个EventSource实例，指向服务器端的SSE URL
        this.source = new EventSource(this.sseUrl+'?userId='+localStorage.getItem('userId'))
        // let reconnectInterval = 30000; // 重连间隔时间（毫秒）
        // 当服务器发送一个消息时，会触发'message'事件
        this.source.addEventListener('notice', this.handleData);
        // 当与服务器的连接打开时触发
        this.source.onopen = () => {
          console.log("Connection is open!");
        };
        // // 当与服务器的连接关闭时触发
        this.source.onerror = () => {
           console.log("Connection is onerror!");
            this.rebuild()
        }

      } else {
        // 浏览器不支持SSE
        console.error("Sorry, your browser does not support server-sent events...");
      }
    },
    rebuild () {
      this.source.close(); // 关闭当前连接
      // this.source = new EventSource(this.sseUrl); // 重新创建EventSource对象尝试重连
    }
  },

}
</script>

<style lang="scss" scoped>
</style>